import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "./Config";
import { Session } from "./Session";
import {
  ITestCreationRequest,
  ITestUpdateRequest,
  ITestMergeRequest,
  ITestCmAssignmentRequest,
  ITestLoginStateRequest,
  ITestPasswordUpdateRequest,
  ITestEventResponse,
} from "../interfaces/ITestEvent";

@Injectable()
export class TestEvents {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    config: Config,
    private session: Session
  ) {
    this.apiUrl = config.apiUrl;
  }

  private headers(): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = this.session.setAuthHeader(headers);
    return { headers };
  }

  private post<T>(path: string, body: T): Observable<ITestEventResponse> {
    return this.http.post<ITestEventResponse>(
      `${this.apiUrl}${path}`,
      body,
      this.headers()
    );
  }

  sendCreation(data: ITestCreationRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/creation", data);
  }

  sendUpdate(data: ITestUpdateRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/update", data);
  }

  sendUsersMerged(data: ITestMergeRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/users_merged", data);
  }

  sendCmAssignmentSet(data: ITestCmAssignmentRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/cm_assignment_set", data);
  }

  sendLoginState(data: ITestLoginStateRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/login_state", data);
  }

  sendPasswordUpdated(data: ITestPasswordUpdateRequest): Observable<ITestEventResponse> {
    return this.post("/test/events/password_updated", data);
  }
}
